import {onEnterViewPort} from "@elements/viewport-utils";
import {renderTemplate} from "./render-template";
import {initInScope, onFind} from "@elements/init-modules-in-scope";
import {
    findIn,
    findAll,
    closest,
    removeClass,
    findAllIn,
    find,
    on,
    off,
    getAttribute,
    addClass,
    hasClass,
    setAttribute
} from '@elements/dom-utils';

const selectors = {
    base: '.js-nav',
    toggler: '.js-nav__toggle-overlay',
    link: '.js-nav__toggle-overlay-link',
    overlay: '.js-nav__overlay',
    mainToggler: '.js-nav__main-toggle',
    mainOverlay: '.js-nav__main-overlay',
    goBack: '.js-nav__go-back',
    closeMobileNav: '.js-nav__close-mobile-nav',
    itemList: '.js-nav__item-list',
    item: '.js-nav__item',
    overlayLink: '.nav-overlay__link',
    wrapper: '.js-nav__wrapper',
    searchToggle: '.js-nav__toggle-overlay--search',
    searchOverlay: '.js-nav__overlay--search',
    openOverlayBtn: '.js-nav-btn__open-overlay'
};

const isTouchDevice = () => {
    return window.matchMedia("(max-width:767px), (pointer: coarse)").matches
}

// const isMobile = matchMedia('(max-width: 767px)').matches || false;

export function init() {
    onFind(selectors.toggler, function (toggler) {
        let baseElement = closest(selectors.base, toggler);
        let overlays = findAllIn(selectors.overlay, baseElement);

        if (!isTouchDevice()) {
            //needed for "menu-aim" delay
            let timeout = 0;
            let timer;

            on('click', function (evt) {
                // If it's a mouse click on the link, we want it to navigate.
                // Since this part of the code is for !isTouchDevice, mouse hover usually handles opening the overlay.
                // We don't want to preventDefault here unless we are specifically on a toggle that should ONLY open overlay.
                // In this project, the requirement says .main-navbar__list-item is also a link.
                // So clicking it should navigate.
            }, toggler);

            on('mouseenter', function (evt) {
                let item = evt.target;
                clearTimeout(timer);

                timer = setTimeout(function () {
                    removeClass('is-open', toggler);
                    let closestOverlay = closest(selectors.overlay, toggler);
                    overlays.map(x => removeClass('show-menu', x));
                    if (closestOverlay) {
                        addClass('show-menu', closestOverlay);
                    }
                    addClass('is-open', item);
                    addClass('show-menu', findIn(selectors.overlay, item));
                }, timeout);
            }, toggler);

            on('mouseleave', function () {
                clearTimeout(timer);

                timer = setTimeout(function () {
                    removeClass('is-open', toggler);
                    let closestOverlay = closest(selectors.overlay, toggler);
                    overlays.map(x => removeClass('show-menu', x));
                    if (closestOverlay) {
                        addClass('show-menu', closestOverlay);
                    }
                }, timeout);
            }, toggler);

            on('focusin', function (evt) {
                let item = evt.currentTarget;
                clearTimeout(timer);

                // If focus is inside the current toggler, we keep it as is
                // but we don't necessarily open the overlay if it was just tabbing onto the link
                if (hasClass('is-open', item)) return;

                // If we are on the openOverlayBtn, we might want to open it (but click does that)
                // The requirement says: "tab once and reach the hidden arrow now displayed and click enter enter"
                // So focusin on the link should NOT open the overlay.
            }, toggler);

            on('focusout', function (evt) {
                // Check if the new focused element is inside the current toggler
                if (!toggler.contains(evt.relatedTarget)) {
                    clearTimeout(timer);
                    removeClass('is-open', toggler);
                    let closestOverlay = closest(selectors.overlay, toggler);
                    overlays.map(x => removeClass('show-menu', x));
                    if (closestOverlay) {
                        addClass('show-menu', closestOverlay);
                    }
                }
            }, toggler);
        } else {
            let link = findIn(selectors.link, toggler);
            on('click', function (evt) {
                // Only prevent default on real touch interactions that are meant to open the menu
                // For mouse clicks or keyboard enter (detail 0), we want the link to be clickable if it's not on the toggle button
                if (evt.pointerType === 'mouse' || (evt.detail === 0 && !evt.pointerType) || (evt.button === 0 && !evt.pointerType && !isTouchDevice())) {
                    return;
                }

                let item = evt.target;
                evt.preventDefault();

                let closestToggler = closest(selectors.toggler, item);
                removeClass('is-open', closestToggler);
                let closestOverlay = closest(selectors.overlay, toggler);

                function bodyClickHandler(evt) {
                    if (!closest('.main-navbar', evt.target)) {
                        evt.preventDefault();
                        let closestItem = find('.js-nav__toggle-overlay.is-open');
                        let closestOverlay = findIn(selectors.overlay, closestItem);
                        removeClass('is-open', closestItem);
                        removeClass('show-menu', closestOverlay);
                        removeBodyClickHandler(bodyClickHandler);
                    }
                }

                overlays.map(x => removeClass('show-menu', x));
                if (closestOverlay) {
                    addClass('show-menu', closestOverlay);
                }
                addClass('is-open', closestToggler);
                addClass('show-menu', findIn(selectors.overlay, closestToggler));

                addBodyClickHandler(bodyClickHandler);

            }, link);
        }

        onFind(selectors.openOverlayBtn, function (btn) {
            on('click', function (evt) {
                evt.preventDefault();
                let parentToggler = closest(selectors.toggler, btn);
                let overlay = findIn(selectors.overlay, parentToggler);

                if (hasClass('is-open', parentToggler)) {
                    removeClass('is-open', parentToggler);
                    removeClass('show-menu', overlay);
                } else {
                    // Close other overlays first if needed
                    overlays.map(x => removeClass('show-menu', x));
                    findAll(selectors.toggler).map(x => removeClass('is-open', x));

                    addClass('is-open', parentToggler);
                    addClass('show-menu', overlay);
                }
            }, btn);
        }, toggler);
    })

    onFind(selectors.base, function (baseElement) {
        onFind(selectors.searchToggle, function (toggle) {
            let searchOverlay = findIn(selectors.searchOverlay, baseElement);
            on('click', function (evt) {
                let searchInput = findIn('.js-nav__overlay-search-input', searchOverlay);

                if (hasClass('show-overlay', searchOverlay)) {
                    hideItem(searchOverlay);
                    hideOverlay(searchOverlay);
                    removeClass('body--freezed', document.body);
                } else {
                    showItem(searchOverlay);
                    showOverlay(searchOverlay);
                    if (searchInput) {
                        focusInput(searchInput);
                    }
                    addClass('body--freezed', document.body);
                }

                function focusInput(input) {
                    // iOS needs focusing directly in the click event
                    input.focus();

                    let timeout = setTimeout(function () {
                        /* timeout is needed because some browsers don't allow focusing a element
                        if it is not visible */
                        input.focus();
                        clearTimeout(timeout);
                    }, 500);
                }

                function bodyClickHandler(evt) {
                    if (!closest('.main-navbar', evt.target)) {
                        evt.preventDefault();
                        hideItem(searchOverlay);
                        hideOverlay(searchOverlay);
                        removeClass('body--freezed', document.body);
                    }
                }

                function showOverlay(overlay) {
                    addClass('show-overlay', overlay);
                    setAttribute('aria-expanded', true, overlay);
                    setAttribute('aria-expanded', true, toggle);
                    if (!isTouchDevice()) {
                        setTimeout(function () {
                            addBodyClickHandler(bodyClickHandler);
                        }, 300);
                    }
                }

                function hideOverlay(overlay) {
                    removeClass('show-overlay', overlay);
                    setAttribute('aria-expanded', false, overlay);
                    setAttribute('aria-expanded', false, toggle);
                    if (!isTouchDevice()) {
                        removeBodyClickHandler(bodyClickHandler);
                    }
                }
            }, toggle);
        });
    });

    function addBodyClickHandler(bodyClickHandler) {
        on('click', bodyClickHandler, document.body);
    }

    function removeBodyClickHandler(bodyClickHandler) {
        off('click', bodyClickHandler, document.body);
    }

    function hideItem(item) {
        removeClass('is-open', item);
        setAttribute('aria-expanded', false, item);
    }

    function showItem(item) {
        addClass('is-open', item);
        setAttribute('aria-expanded', true, item);
    }

    onFind(selectors.item, function (itemElement) {
        let baseElement = closest(selectors.itemList, itemElement);

        if (!isTouchDevice()) {
            on('mouseenter', function () {
                addClass('is-open', baseElement);
            }, baseElement);

            on('mouseleave', function () {
                removeClass('is-open', baseElement);
            }, baseElement)

            on('keydown', function (evt) {
                const key = evt.key;
                if (key !== 'ArrowDown' && key !== 'ArrowUp') {
                    return;
                }

                const currentLink = findIn(selectors.overlayLink, itemElement);
                if (!currentLink) {
                    return;
                }

                const items = findAllIn(selectors.item, baseElement);
                const index = items.indexOf(itemElement);

                if (key === 'ArrowDown') {
                    evt.preventDefault();
                    const nextItem = items[index + 1];
                    if (nextItem) {
                        const nextLink = findIn(selectors.overlayLink, nextItem);
                        if (nextLink) {
                            nextLink.focus();
                        }
                    }
                } else if (key === 'ArrowUp') {
                    evt.preventDefault();
                    const prevItem = items[index - 1];
                    if (prevItem) {
                        const prevLink = findIn(selectors.overlayLink, prevItem);
                        if (prevLink) {
                            prevLink.focus();
                        }
                    }
                }
            }, itemElement);
        }
    })

    onFind(selectors.mainToggler, function (toggler) {
        if (isTouchDevice()) {
            on('click', function (evt) {
                let item = toggler;
                evt.preventDefault();

                if (!hasClass('is-open', item)) {
                    addClass('is-open', item);
                    setAttribute('aria-expanded', 'true', item);
                    addClass('show-menu', find(selectors.mainOverlay));
                    addClass('nav-is-open', find('body'));

                    window.dataLayer = window['dataLayer'] || [];

                    let dataLayerData = {
                        'event': 'genericGtmEvent',
                        'genericEventCategory': 'Navigation Mobile',
                        'genericEventAction': 'Hamburger-Menü-Icon',
                        'genericEventLabel': 'öffnen'
                    };

                    window.dataLayer.push(dataLayerData);


                } else {
                    removeClass('is-open', item);
                    setAttribute('aria-expanded', 'false', item);
                    removeClass('show-menu', find(selectors.mainOverlay));
                    removeClass('nav-is-open', find('body'));

                    window.dataLayer = window['dataLayer'] || [];

                    let dataLayerData = {
                        'event': 'genericGtmEvent',
                        'genericEventCategory': 'Navigation Mobile',
                        'genericEventAction': 'Hamburger-Menü-Icon',
                        'genericEventLabel': 'schließen'
                    };

                    window.dataLayer.push(dataLayerData);
                }
            }, toggler);

        }
    });

    onFind(selectors.goBack, function (button) {
        if (isTouchDevice()) {
            on('click', function (evt) {
                let item = evt.target;
                let closestOverlay = closest(selectors.overlay, item);
                removeClass('show-menu', closestOverlay);
                let closestToggler = closest(selectors.toggler, item);
                removeClass('is-open', closestToggler);
            }, button);
        }
    });

    onFind(selectors.closeMobileNav, function (link) {
        if (isTouchDevice()) {
            on('click', function (evt) {
                let mainToggler = find(selectors.mainToggler);
                removeClass('is-open', mainToggler);
                setAttribute('aria-expanded', 'false', mainToggler);
                removeClass('show-menu', find(selectors.mainOverlay));
                removeClass('nav-is-open', find('body'));
            }, link);
        }
    });

}